
<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"LOCATIONS"'></app-infrastructure-header>

<!-- Main Screen which shows the Locations and Location Instances -->
<div style="clear: both" id="objectContentPane">
	<div style="margin: 12px">

		<!-- Tab Navigation Control -->
		<ul class="nav nav-tabs">
			<li class="active"><a data-toggle="tab" href="#location-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> LOCATIONS</a></li>
			<li class=""><a data-toggle="tab" href="#locations-tab" aria-expanded="false"><i class="fa fa-star-o"></i> LOCATION TYPES</a></li>
		</ul>

		<!-- Tab Content -->
		<div class="tab-content">

			<!-- Locations Tab -->
			<div id="locations-tab" class="tab-pane fade">

				<!-- Add Location Type and Options buttons -->
				<button (click)="addLocationClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em> ADD
					LOCATION TYPE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedLocationClicked()" [class.disabled]="!isSingleLocationSelected()">
							<a><em class="fa fa-pencil"></em> EDIT</a>
						</li>
						<li (click)="duplicateSelectedLocationClicked()" [class.disabled]="!isSingleLocationSelected()">
							<a><em class="fa fa-clone"></em> DUPLICATE</a>
						</li>
						<li (click)="deleteSelectedLocationsClicked()" [class.disabled]="!isAnyLocationsSelected()">
							<a><em class="fa fa-remove"></em> DELETE</a>
						</li>
						<li class="divider"></li>
						<li (click)="addSelectedLocationsToGroupClicked()" [class.disabled]="!isAnyLocationsSelected()">
							<a><em class="fa fa-plus"></em> ADD TO GROUP</a>
						</li>
						<li (click)="removeSelectedLocationsFromGroupClicked()"
							[class.disabled]="!isAnyLocationsSelected()"><a><em class="fa fa-remove"></em> REMOVE FROM
								GROUP</a></li>
						<li (click)="manageLocationGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE GROUPS</a>
						</li>
					</ul>
				</div>

        <!-- "Filter" Button w/ drop down options -->
		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
				<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li *ngFor="let filterOption of filterOptionForLocation" (click)="onFilterOptionForLocationClicked(filterOption)">
					<a>{{ filterOption.label }}</a>
				</li>
			</ul>
		</div>

		<!-- Filter Label (if a Filter Option is selected) -->
		<div *ngIf="selectedFilterOptionForLocation?.column != null" class="dropdown btn-group edgefinityHeader"
			style="display:inline-block">
			{{ selectedFilterOptionForLocation.label }}
		</div>
		
		<!-- Filter Value (if a Filter Option is selected)-->
		<div *ngIf="selectedFilterOptionForLocation?.column != null" class="dropdown btn-group edgefinityHeader"
			style="display:inline-block">
			<input class="form-control ng-pristine ng-valid ng-untouched" type="text" [(ngModel)]="filterOptionValueForLocation"
				(ngModelChange)="onFilterValueForLocationChanged()">
		</div>

		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
					class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForTypes(value)" [class.active]="value === selectedPageSizeValueForTypes">
							<a>{{ value }}</a>
						</li>
					</ul>
		</div>

				<!-- Locations -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllLocationsSelected()"
										(change)="setAllLocationsSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let location of mLocations | paginate: {id: 'locations_paginations', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageForLocation, totalItems: totalNumberOfLocation }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="location.mSelected" /></td>
								<td (click)="editLocation(location.mLocation)">{{location.mLocation.name}}</td>
								<td>
									<ng-container
										*ngIf="location.mLocation.groups != null && location.mLocation.groups.length > 0">
										<ng-container *ngFor="let group of location.mLocation.groups">
											<button (click)="showGroup(group)"
												class="groupButton">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for Driver Object -->
				<pagination-controls class="pagination" id="locations_paginations"
					(pageChange)="pageChangedLocation($event)" [directionLinks]="true" nextLabel="Next"
					previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>

			<!-- Location Instances Tab -->
			<div id="location-instances-tab" class="tab-pane fade active in">

				<!-- Add Location and Options buttons -->
				<button (click)="addLocationInstanceClicked()" type="button" class="btn btn-ef"><em
						class="fa fa-plus"></em> ADD LOCATION</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedLocationInstanceClicked()"
							[class.disabled]="!isSingleLocationInstanceSelected()"><a><em class="fa fa-pencil"></em>
								EDIT</a></li>
						<li (click)="duplicateSelectedLocationInstanceClicked()"
							[class.disabled]="!isSingleLocationInstanceSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedLocationInstancesClicked()"
							[class.disabled]="!isAnyLocationInstancesSelected()"><a><em class="fa fa-remove"></em>
								DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedLocationInstancesToGroupClicked()"
							[class.disabled]="!isAnyLocationInstancesSelected()"><a><em class="fa fa-plus"></em> ADD TO
								GROUP</a></li>
						<li (click)="removeSelectedLocationInstancesFromGroupClicked()"
							[class.disabled]="!isAnyLocationInstancesSelected()"><a><em class="fa fa-remove"></em>
								REMOVE FROM GROUP</a></li>
						<li (click)="manageLocationInstanceGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
					</ul>
				</div>

				<!-- "Filter" Button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let filterOption of filterOptionForLocationInstances" (click)="onFilterOptionForLocationInstanceClicked(filterOption)">
							<a>{{ filterOption.label }}</a>
						</li>
					</ul>
				</div>

				<!-- Filter Label (if a Filter Option is selected) -->
				<div *ngIf="selectedFilterOptionForLocationInstance?.column != null" class="dropdown btn-group edgefinityHeader"
					style="display:inline-block">
					{{ selectedFilterOptionForLocationInstance.label }}
				</div>
				
				<!-- Filter Value (if a Filter Option is selected)-->
				<div *ngIf="selectedFilterOptionForLocationInstance?.column != null" class="dropdown btn-group edgefinityHeader"
					style="display:inline-block">
					<input class="form-control ng-pristine ng-valid ng-untouched" type="text" [(ngModel)]="filterOptionValueForLocationInstance"
						(ngModelChange)="onFilterValueForLocationInstanceChanged()">
				</div>

				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForInstances(value)" [class.active]="value === selectedPageSizeValueForInstances">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>


				<!-- Location Instances -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllLocationInstancesSelected()"
										(change)="setAllLocationInstancesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Location Type</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let locationInstance of mLocationInstances | paginate: {id: 'locationinstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageForLocationInstance, totalItems: totalNumberOfLocationInstances }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="locationInstance.mSelected" /></td>
								<td (click)="editLocationInstance(locationInstance.mLocationInstance)"  (contextmenu)="fetchFunctionList($event, locationInstance.mLocationInstance)">
									{{locationInstance.mLocationInstance.name}}</td>
								<td (click)="editLocationInstance(locationInstance.mLocationInstance)">
									{{locationInstance.mLocationInstance.location.name}}</td>
								<td>
									<ng-container
										*ngIf="locationInstance.mLocationInstance.groups != null && locationInstance.mLocationInstance.groups.length > 0">
										<ng-container *ngFor="let group of locationInstance.mLocationInstance.groups">
											<button (click)="showGroup(group)"
												class="groupButton">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination conyrols for "Driver Object Instance" -->
				<pagination-controls class="pagination" id="locationinstance_pagination"
						(pageChange)="pageChangedLocationInstance($event)" [directionLinks]="true" nextLabel="Next"
						previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>
		</div>
	</div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance"
	[instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [instanceType]="mInstanceType"
	[instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
	[selectedLocation]="mSelectedLocation" [availableLocations]="mAvailableLocations"
	(createOrUpdateEvent)="createOrUpdateEntityInstance()" (showGroup)="showGroup($event)"
	(selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(refreshInstanceDataEvent)="refreshInstanceData()" (selectedLocationChangedEvent)="selectedLocationChanged($event)">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>

<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance" [instanceType]="mInstanceType"
	[function]="selectedFunction"></app-general-function-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>